export default __webpack_public_path__ + "static/media/carry 1.619bbb44.png";